import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import FormAluno from "./FormAluno";
import TableAssociado from "./TableAssociado";
import "./Associado.css";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";

function Associado({
  showModal,
  setShowModal,
  registraPresencaPut,
  setRegistraPresencaPut,
  objPresenca,
  setObjPresenca,
associado ,
setAssociado,
executaConsultaAssociado,
setExecutaConsultaAssociado}) {
  const values = [true, "sm-down", "md-down", "lg-down", "xl-down", "xxl-down"];
  const [fullscreen, setFullscreen] = useState(true);
  const [associadoDe, setAssociadoDe] = useState(150);
  const [idAluno, setidAluno] = useState(null);
  const [associadoAte, setAssociadoAte] = useState(160);
  const [indiceAssociado, setIndiceAssociado] = useState(0);
  const [nomeAssociado, setNomeAssociado] = useState("");
  const [handleSearchControl, setHandleSearchControl] = useState(false);
  const fechaModal = () => {
    setShowModal(false);
  };
  const atualizaHandleSearchControl = (operac) => {
    setHandleSearchControl(operac);
  };

  const handleSearch = (event) => {
    setNomeAssociado(event.target.value);
    atualizaHandleSearchControl(true);
    if (associado.length != 0) {
      setExecutaConsultaAssociado(executaConsultaAssociado + 1);
    }
    if (event.target.value === "") {
      atualizaHandleSearchControl(false);
      setAssociadoAte(100);
    }
  };

  const atualizaAssociado = (result) => {
    setAssociado(result);
  };

  useEffect(() => {
    function consultaAssociado() {
      let url = "";

      if (!handleSearchControl) {
        url = `https://ricktool.com/api/aluno`;
      } else {
        url = `https://ricktool.com/api/alunoNome?nomealuno=${nomeAssociado}`;
      }
      fetch(url)
        .then((response) => response.json())
        .then((result) => {
          atualizaAssociado(result);
        })
        .catch((error) => console.error("Erro ao buscar card", error));
    }
    console.log("dentro da consulta")
    consultaAssociado();
  }, [handleSearchControl, executaConsultaAssociado]);

  return (
    <>
      <Modal
        show={showModal}
        fullscreen={fullscreen}
        onHide={() => fechaModal()}
      >
        <Modal.Header
          className="modalHeader"
          data-bs-theme="dark"
          closeButton
          onClick={() => fechaModal()}
        >
          <Modal.Title className="modalTitulo">Cadastro de Aluno</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {associado != null && (
            <div className="associado">
              <div className="divForm">
                <FormAluno
                  className="form"
                  associado={associado}
                  setAssociado={setAssociado}
                  indiceAssociado={indiceAssociado}
                  executaConsultaAssociado={executaConsultaAssociado}
                  setExecutaConsultaAssociado={setExecutaConsultaAssociado}
                  registraPresencaPut={registraPresencaPut}
                  setRegistraPresencaPut={setRegistraPresencaPut}
                  objPresenca={objPresenca}
                  setObjPresenca={setObjPresenca}
                />
              </div>
              <div className="divContPesquisaTable">
                <div className="pesquisa">
                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder="Pesquisa (código ou nome)"
                      className=" mr-sm-2"
                      value={nomeAssociado}
                      onChange={handleSearch}
                    />
                    {nomeAssociado && ( // O botão só aparece se houver texto
                      <i
                        class="bi bi-x-lg"
                        onClick={() => {
                          setNomeAssociado("");
                        }}
                      ></i>
                    )}
                  </InputGroup>
                </div>

                <div className="divTable">
                  <TableAssociado
                    className="table"
                    associado={associado}
                    setAssociado={setAssociado}
                    indiceAssociado={indiceAssociado}
                    setIndiceAssociado={setIndiceAssociado}
                  />
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Associado;
